export const environment = {
  production: false,
  'API_URL': 'https://api.innovation-csai-dev.org',
  'GOOGLE_CLIENT_ID': 'valid-client-id',
  'NEWS_PAGE_SIZE': '6',
  'EVENTS_MAX_COUNT': '4'
};
